module.exports = __webpack_public_path__ + "static/media/img1.c7183c48.png";